"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum;
(function (TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum) {
    TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum["Active"] = "ACTIVE";
    TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum["InFlight"] = "IN_FLIGHT";
    TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum["Historical"] = "HISTORICAL";
})(TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum = exports.TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum || (exports.TableauPublishedconnectionV1PublishedConnectionRevisionTypeEnum = {}));
function TableauPublishedconnectionV1PublishedConnectionFromJSON(json) {
    return TableauPublishedconnectionV1PublishedConnectionFromJSONTyped(json, false);
}
exports.TableauPublishedconnectionV1PublishedConnectionFromJSON = TableauPublishedconnectionV1PublishedConnectionFromJSON;
function TableauPublishedconnectionV1PublishedConnectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'parentSiteLuid': !runtime_1.exists(json, 'parent_site_luid') ? undefined : json['parent_site_luid'],
        'luid': !runtime_1.exists(json, 'luid') ? undefined : json['luid'],
        'change': !runtime_1.exists(json, 'change') ? undefined : json['change'],
        'parentProjectLuid': !runtime_1.exists(json, 'parent_project_luid') ? undefined : json['parent_project_luid'],
        'ownerLuid': !runtime_1.exists(json, 'owner_luid') ? undefined : json['owner_luid'],
        'revisableProperties': !runtime_1.exists(json, 'revisable_properties') ? undefined : _1.TableauPublishedconnectionV1PublishedConnectionRevisablePropertiesFromJSON(json['revisable_properties']),
        'revisionType': !runtime_1.exists(json, 'revision_type') ? undefined : json['revision_type'],
        'revisionLuid': !runtime_1.exists(json, 'revision_luid') ? undefined : json['revision_luid'],
        'historicalRevisionNumber': !runtime_1.exists(json, 'historical_revision_number') ? undefined : json['historical_revision_number'],
        'vizportalId': !runtime_1.exists(json, 'vizportal_id') ? undefined : json['vizportal_id'],
        'tags': !runtime_1.exists(json, 'tags') ? undefined : _1.TableauPublishedconnectionV1TagCollectionFromJSON(json['tags']),
        'hasRelatedActiveRevision': !runtime_1.exists(json, 'has_related_active_revision') ? undefined : json['has_related_active_revision'],
    };
}
exports.TableauPublishedconnectionV1PublishedConnectionFromJSONTyped = TableauPublishedconnectionV1PublishedConnectionFromJSONTyped;
function TableauPublishedconnectionV1PublishedConnectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'parent_site_luid': value.parentSiteLuid,
        'luid': value.luid,
        'change': value.change,
        'parent_project_luid': value.parentProjectLuid,
        'owner_luid': value.ownerLuid,
        'revisable_properties': _1.TableauPublishedconnectionV1PublishedConnectionRevisablePropertiesToJSON(value.revisableProperties),
        'revision_type': value.revisionType,
        'revision_luid': value.revisionLuid,
        'historical_revision_number': value.historicalRevisionNumber,
        'vizportal_id': value.vizportalId,
        'tags': _1.TableauPublishedconnectionV1TagCollectionToJSON(value.tags),
        'has_related_active_revision': value.hasRelatedActiveRevision,
    };
}
exports.TableauPublishedconnectionV1PublishedConnectionToJSON = TableauPublishedconnectionV1PublishedConnectionToJSON;
